import { useSyncExternalStore } from 'react';

// The page's last input, kept from load so a list opened from the keyboard starts with the highlight ring.
const inputModality = { keyboard: false, listeners: new Set<() => void>() };
function setKeyboardInput(keyboard: boolean) {
  if (inputModality.keyboard === keyboard) return;
  inputModality.keyboard = keyboard;
  for (const listener of inputModality.listeners) listener();
}
if (typeof document !== 'undefined') {
  document.addEventListener('keydown', () => setKeyboardInput(true), true);
  document.addEventListener('pointerdown', () => setKeyboardInput(false), true);
  document.addEventListener('pointermove', () => setKeyboardInput(false), true);
}
function subscribeInputModality(listener: () => void) {
  inputModality.listeners.add(listener);
  return () => {
    inputModality.listeners.delete(listener);
  };
}

/** Whether the page's last input was a key press rather than a pointer, for rings that only keyboard users need. */
export function useKeyboardNav(): boolean {
  return useSyncExternalStore(
    subscribeInputModality,
    () => inputModality.keyboard,
    () => false,
  );
}
